import React, { PureComponent } from "react";

import styles from "./Pellet.local.scss";
import classnames from "classnames";
import _ from "i18n";

export default class PelletComponent extends PureComponent {
  render() {
    const { pellets, fetched } = this.props;

    let aPBookedSum = "",
      aPForwardedSum = "",
      aPToAcceptSum = "",
      aRBookedSum = "",
      aRForwardedSum = "",
      aRToAcceptSum = "",
      bwn2And5 = "",
      gt5 = "",
      lt2 = "";

    if (fetched && pellets && pellets.length > 0 && pellets[0].btbStats) {
      aPBookedSum = pellets[0].btbStats.aPBookedSum;
      aPForwardedSum = pellets[0].btbStats.aPForwardedSum;
      aPToAcceptSum = pellets[0].btbStats.aPToAcceptSum;
      aRBookedSum = pellets[0].btbStats.aRBookedSum;
      aRForwardedSum = pellets[0].btbStats.aRForwardedSum;
      aRToAcceptSum = pellets[0].btbStats.aRToAcceptSum;
      if (pellets[0].btbStats.delays) {
        bwn2And5 = pellets[0].btbStats.delays.bwn2And5;
        gt5 = pellets[0].btbStats.delays.gt5;
        lt2 = pellets[0].btbStats.delays.lt2;
      }
    }

    return (
      <div className={classnames(styles.pellet)}>
        <div className={classnames(styles.details)}>
          <div className={classnames(styles.header, "grid-x")}>
            <span className="cell small-4" />
            <span className={classnames(styles.center, "cell small-4")}>
              {_("Purchase invoices")}
            </span>
            <span className={classnames(styles.center, "cell small-4")}>
              {_("Sales invoices")}
            </span>
          </div>
          <ul className={styles.details}>
            <li className="grid-x">
              <span className="cell small-4">{_("To accept")}</span>
              <span className={classnames(styles.center, "cell small-4")}>
                <ul className={styles.number}>
                  <li className={styles.white}>{aPToAcceptSum}</li>
                </ul>
              </span>
              <span className={classnames(styles.center, "cell small-4")}>
                <ul className={styles.number}>
                  <li className={styles.white}>{aRToAcceptSum}</li>
                </ul>
              </span>
            </li>
            <li className="grid-x">
              <span className="cell small-4">{_("Transferred")}</span>
              <span className={classnames(styles.center, "cell small-4")}>
                <ul className={styles.number}>
                  <li className={styles.white}>{aPForwardedSum}</li>
                </ul>
              </span>
              <span className={classnames(styles.center, "cell small-4")}>
                <ul className={styles.number}>
                  <li className={styles.white}>{aRForwardedSum}</li>
                </ul>
              </span>
            </li>
            <li className="grid-x">
              <span className="cell small-4">{_("Recognized")}</span>
              <span className={classnames(styles.center, "cell small-4")}>
                <ul className={styles.number}>
                  <li className={styles.white}>{aPBookedSum}</li>
                </ul>
              </span>
              <span className={classnames(styles.center, "cell small-4")}>
                <ul className={styles.number}>
                  <li className={styles.white}>{aRBookedSum}</li>
                </ul>
              </span>
            </li>
            <li className="grid-x">
              <span className="cell small-4">{_("Delays")}</span>
              <span className={classnames(styles.center, "cell small-8")}>
                <ul className={styles.number}>
                  <li className={styles.red}>{gt5}</li>
                  <li className={styles.orange}>{bwn2And5}</li>
                  <li className={styles.green}>{lt2}</li>
                </ul>
              </span>
            </li>
          </ul>
          <ul className={styles.annexe}>
            <li className={styles.cRed}>{_("More than 5 days")}</li>
            <li className={styles.cOrange}>{_("Between 2 and 5 days")}</li>
            <li className={styles.cGreen}>{_("Less than 2 days")}</li>
          </ul>
        </div>
      </div>
    );
  }
}

// Conn



// WEBPACK FOOTER //
// ./src/components/Community/ClientSpace/Pellet/PelletComponent.js